
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.751 7.118a.751.751 0 01-.156-1.484l5.869-1.247-.156-.731a2.247 2.247 0 01.317-1.698c.328-.504.833-.85 1.421-.974l4.401-.935a2.231 2.231 0 011.692.316c.503.328.849.833.973 1.421l.155.73 5.869-1.247a.753.753 0 01.889.577c.042.196.004.396-.105.564s-.277.283-.473.325l-6.56 1.395a.386.386 0 01-.042.012L8.51 5.701a.482.482 0 01-.052.008L1.907 7.101a.745.745 0 01-.156.017zm7.605-4.667a.747.747 0 00-.581.889l.156.735L14.8 2.827l-.155-.731a.748.748 0 00-.884-.581l-4.405.936zM10.751 18.75a.75.75 0 01-.75-.75v-7.5a.75.75 0 011.5 0V18a.75.75 0 01-.75.75zM15.251 18.75a.75.75 0 01-.75-.75v-7.5a.75.75 0 011.5 0V18a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"d":"M7.631 24a2.262 2.262 0 01-2.241-2.064L4.353 9.439a.748.748 0 111.494-.125l1.037 12.497c.032.386.36.688.747.688h10.735c.392 0 .72-.302.752-.688L20.433 6.75h-1.807a.75.75 0 010-1.5h2.625a.75.75 0 01.747.816L20.613 21.94A2.262 2.262 0 0118.371 24H7.631z"}})])
          )
        }
      }
    